/* Klaviyo "Active on Site" tracking
 * Fires once per session if marketing terms consent is accepted in checkout
 * Sends: Browser, OS, URL
 */

export default ({ app, store }, inject) => {
  if (process.client) {
    const trackActiveOnSite = () => {
      // Check if already tracked this session (using sessionStorage for persistence)
      if (sessionStorage.getItem('klaviyoActiveOnSiteTracked')) {
        return
      }

      if (sessionStorage.getItem('klaviyoTrackingAllowed') !== 'true') {
        return
      }

      const user = store.getters['user/user/getUser']
      const email = user?.email || store.getters['cart/basket/getBasket']?.billingAddress?.email || null
      if (!email) {
        return
      }

      // Mark as pending immediately to prevent duplicate in-flight requests
      sessionStorage.setItem('klaviyoActiveOnSiteTracked', 'pending')

      // Get browser info
      const ua = navigator.userAgent
      let browser = 'Unknown'
      if (ua.includes('Firefox')) browser = 'Firefox'
      else if (ua.includes('Chrome')) browser = 'Chrome'
      else if (ua.includes('Safari')) browser = 'Safari'
      else if (ua.includes('Edge')) browser = 'Edge'

      // Get OS info
      let os = 'Unknown'
      if (ua.includes('Windows')) os = 'Windows'
      else if (ua.includes('Mac')) os = 'MacOS'
      else if (ua.includes('Linux')) os = 'Linux'
      else if (ua.includes('Android')) os = 'Android'
      else if (ua.includes('iOS')) os = 'iOS'

      const eventData = {
        Browser: browser,
        OS: os,
        URL: window.location.pathname
      }

      return app.$repositories.klaviyo.track('Active on Site', eventData, email, null)
        .then(() => {
          sessionStorage.setItem('klaviyoActiveOnSiteTracked', 'true')
        })
        .catch(() => {
          sessionStorage.removeItem('klaviyoActiveOnSiteTracked')
        })
    }

    inject('trackKlaviyoActiveOnSite', trackActiveOnSite)

    // Track on first page load
    app.router.afterEach((to, from) => {
      // Small delay to ensure Klaviyo repository is ready
      setTimeout(() => {
        trackActiveOnSite()
      }, 100)
    })
  }
}
